// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"r_b0","modalDialog":"r_b0","modal-title":"r_b1","modalTitle":"r_b1","modal-subtitle":"r_b2","modalSubtitle":"r_b2"};